import { Injectable } from '@angular/core';
import { StatsService } from './stats-service.service';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable()
export class InterceptorService implements HttpInterceptor {

    constructor(private statsService: StatsService) {

    }

    intercept(
        req: HttpRequest<any>,
        next: HttpHandler
    ): Observable<HttpEvent<any>> {

        return next.handle(req).pipe(
            map((event: HttpEvent<any>) => {
                if (event instanceof HttpResponse) {
                    if (event.status === 200 && event.body && event.body.AutoExpertAppStats) {
                        this.statsService.stats = event.body.AutoExpertAppStats;
                    }
                }
                return event;
            }));
    }
}